module.exports = __webpack_public_path__ + "static/media/drive-right-folder.b6e84146.svg";